/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ImportResultV2 {
  reportType?: number;
  fileName?: string;
  totalParsed?: number;
  newRows?: number;
  updatedRows?: number;
  duplicateRows?: number;
  unreconciledRows?: number;
  totalInDatabase?: number;
}
